import * as Types from '../../../generated/types.cms';

import { endpoint, fetchParams } from '@payflip/employee-client/cms-gql-config';
import { useQuery, UseQueryOptions } from 'react-query';

function fetcher<TData, TVariables>(query: string, variables?: TVariables) {
  return async (): Promise<TData> => {
    const res = await fetch(endpoint as string, {
    method: "POST",
    ...(fetchParams),
      body: JSON.stringify({ query, variables }),
    });

    const json = await res.json();

    if (json.errors) {
      const { message } = json.errors[0];

      throw new Error(message);
    }

    return json.data;
  }
}
export type GetManualSigningOutletQueryVariables = Types.Exact<{
  locale: Types.Scalars['I18NLocaleCode']['input'];
}>;


export type GetManualSigningOutletQuery = { __typename?: 'Query', common?: { __typename?: 'CommonEntityResponse', data?: { __typename?: 'CommonEntity', id?: string | null, attributes?: { __typename?: 'Common', cancel?: string | null } | null } | null } | null, employeeBudgetActivationOutlet?: { __typename?: 'EmployeeBudgetActivationOutletEntityResponse', data?: { __typename?: 'EmployeeBudgetActivationOutletEntity', id?: string | null, attributes?: { __typename?: 'EmployeeBudgetActivationOutlet', goBackLink?: string | null, confirmSignatureTitle?: string | null, confirmSignatureButtonText?: string | null, noTemplateFoundText?: string | null, downloadFundingDocumentTitle?: string | null, downloadFundingDocumentDescription?: string | null, uploadSignedDocumentTitle?: string | null, uploadSignedDocumentDescription?: string | null, downloadFundingDocumentButtonText?: string | null, budgetSuccessfullyActivatedToastText?: string | null } | null } | null } | null, adminToast?: { __typename?: 'AdminToastEntityResponse', data?: { __typename?: 'AdminToastEntity', id?: string | null, attributes?: { __typename?: 'AdminToast', genericErrorMessage?: string | null, genericSuccessMessage?: string | null } | null } | null } | null };



export const GetManualSigningOutletDocument = `
    query GetManualSigningOutlet($locale: I18NLocaleCode!) {
  common(locale: $locale) {
    data {
      id
      attributes {
        cancel
      }
    }
  }
  employeeBudgetActivationOutlet(locale: $locale) {
    data {
      id
      attributes {
        goBackLink
        confirmSignatureTitle
        confirmSignatureButtonText
        noTemplateFoundText
        downloadFundingDocumentTitle
        downloadFundingDocumentDescription
        uploadSignedDocumentTitle
        uploadSignedDocumentDescription
        downloadFundingDocumentButtonText
        budgetSuccessfullyActivatedToastText
      }
    }
  }
  adminToast(locale: $locale) {
    data {
      id
      attributes {
        genericErrorMessage
        genericSuccessMessage
      }
    }
  }
}
    `;

export const useGetManualSigningOutletQuery = <
      TData = GetManualSigningOutletQuery,
      TError = unknown
    >(
      variables: GetManualSigningOutletQueryVariables,
      options?: UseQueryOptions<GetManualSigningOutletQuery, TError, TData>
    ) => {
    
    return useQuery<GetManualSigningOutletQuery, TError, TData>(
      ['GetManualSigningOutlet', variables],
      fetcher<GetManualSigningOutletQuery, GetManualSigningOutletQueryVariables>(GetManualSigningOutletDocument, variables),
      options
    )};
